module.exports = __webpack_public_path__ + "img/no-user.6f6bbb16.png";